import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import NumericField from '../../numeric-field';

type BoundsProps = {
  params: types.optimizer.Bounds;
  children?: React.ReactNode;
  disableLower?: boolean;
  isPercent?: boolean;
  setParams: (_params: types.optimizer.Bounds) => void;
  id?: string;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const Bounds = ({
  params,
  setParams,
  isPercent = false,
  disableLower,
  children = null,
  id,
  readOnly,
  validationDef,
}: BoundsProps) => {
  return (
    <>
      <mui.core.Grid container spacing={4} rowSpacing={3}>
        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <NumericField
            textFieldProps={{
              label: 'Lower Bound',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
              error: validationDef?.fields?.includes(`lower_bound_${id}`),
            }}
            disabled={readOnly || disableLower}
            value={params.lower_bound}
            setValue={(v) => setParams({ ...params, lower_bound: v })}
            suffix={isPercent ? '%' : ''}
            dividerOption={isPercent ? enums.NUMBER_FORMATTERS_ENUM.HUNDRED : undefined}
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <NumericField
            textFieldProps={{
              label: 'Upper Bound',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
              error: validationDef?.fields?.includes(`upper_bound_${id}`),
            }}
            disabled={readOnly}
            value={params.upper_bound}
            setValue={(v) => setParams({ ...params, upper_bound: v })}
            suffix={isPercent ? '%' : ''}
            dividerOption={isPercent ? enums.NUMBER_FORMATTERS_ENUM.HUNDRED : undefined}
          />
        </mui.core.Grid>
      </mui.core.Grid>
      {children}
    </>
  );
};

export default Bounds;
